import { useLocation } from 'react-router-dom';

export function useReportsBackHref(): '/reports' | '/reporting' {
  const { pathname } = useLocation();
  return pathname.startsWith('/reports') ? '/reports' : '/reporting';
}
